/* eslint-disable */
import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import './index.scss';
import '@/component/page';
import Header from '@/component/header';
import Footer from '@/component/footer';
import PageHeader from '@/component/pageheader';
import StructureCatolog from '@/component/business/structure-catolog';
import {
    megaHome2025,
    megaUltra2025,
    l9Ultra2025,
    l9Pro2025,
    l8Ultra2025,
    l8Pro2025,
    l8Max2025,
    l7Ultra2025,
    l7Pro2025,
    l7Max2025,
    l6Max2025,
    l6Pro2025,
    m10,
    l6Pro2024,
    l6Max2024,
    l7Air2023,
    l7Max2023,
    l7Pro2023,
    l7Pro2024,
    l7Ultra2024,
    l7Max2024,
    l8Air2023,
    l8Max2022,
    l8Pro2022,
    l8Pro2024,
    l8Ultra2024,
    l8Max2024,
    l9Max2022,
    l9Pro2022,
    l9Ultra2024,
    l9Pro2024,
    megaUltra2024
} from './arrInit';
import ModelSelect from '@/component/LXModelSelect';
import pmsService from '@/service/pms';
import commonUtil from '@/util/common';

const pageCode = commonUtil.getQueryStringByName('pageCode') || 'manual-user';
const previewToken = commonUtil.getQueryStringByName('previewToken');

interface IModels {
    modelName: string;
}
interface ISeries {
    seriesName: string;
    modelList: Array<IModels>;
}
interface State {
    showUrl: string;
    firstLevelItem?: object;
    secondLevelItem?: object;
    showItem?: object;
    selectListData?: Array<ISeries>;
    modelName?: string;
    m10list?: Array<any>;
    l6ProList2024?: Array<any>;
    l6MaxList2024?: Array<any>;
    l7AirList2023?: Array<any>;
    l7MaxList2023?: Array<any>;
    l7ProList2023?: Array<any>;
    l7ProList2024?: Array<any>;
    l7UltraList2024?: Array<any>;
    l7MaxList2024?: Array<any>;
    l8AirList2023?: Array<any>;
    l8MaxList2022?: Array<any>;
    l8ProList2022?: Array<any>;
    l8ProList2024?: Array<any>;
    l8UltraList2024?: Array<any>;
    l8MaxList2024?: Array<any>;
    l9MaxList2022?: Array<any>;
    l9ProList2022?: Array<any>;
    l9UltraList2024?: Array<any>;
    l9ProList2024?: Array<any>;
    megaUltraList2024?: Array<any>;
    megaUltraList2025?: Array<any>;
    megaHomeList2025?: Array<any>;
    l6ProList2025?: Array<any>;
    l6MaxList2025?: Array<any>;
    l7MaxList2025?: Array<any>;
    l7ProList2025?: Array<any>;
    l7UltraList2025?: Array<any>;
    l8MaxList2025?: Array<any>;
    l8ProList2025?: Array<any>;
    l8UltraList2025?: Array<any>;
    l9ProList2025?: Array<any>;
    l9UltraList2025?: Array<any>;
    carBookArr: Array<any>;
    seriesName: string;
}

class App extends Component<any, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            showUrl: '',
            selectListData: [],
            modelName: '',
            seriesName: '',
            m10list: m10,
            l6ProList2024: l6Pro2024,
            l6MaxList2024: l6Max2024,
            l7AirList2023: l7Air2023,
            l7MaxList2023: l7Max2023,
            l7ProList2023: l7Pro2023,
            l7ProList2024: l7Pro2024,
            l7UltraList2024: l7Ultra2024,
            l7MaxList2024: l7Max2024,
            l8AirList2023: l8Air2023,
            l8MaxList2022: l8Max2022,
            l8ProList2022: l8Pro2022,
            l8ProList2024: l8Pro2024,
            l8UltraList2024: l8Ultra2024,
            l8MaxList2024: l8Max2024,
            l9MaxList2022: l9Max2022,
            l9ProList2022: l9Pro2022,
            l9UltraList2024: l9Ultra2024,
            l9ProList2024: l9Pro2024,
            megaUltraList2024: megaUltra2024,
            megaUltraList2025: megaUltra2025,
            megaHomeList2025: megaHome2025,
            l6ProList2025: l6Pro2025,
            l6MaxList2025: l6Max2025,
            l7MaxList2025: l7Max2025,
            l7ProList2025: l7Pro2025,
            l7UltraList2025: l7Ultra2025,
            l8MaxList2025: l8Max2025,
            l8ProList2025: l8Pro2025,
            l8UltraList2025: l8Ultra2025,
            l9ProList2025: l9Pro2025,
            l9UltraList2025: l9Ultra2025,
            carBookArr: []
        };
    }

    componentDidMount() {
        this.getModelSeries();
        this.selectCarBook();
    }

    // 获取用户手册页面变形金刚页面数据
    async getPageDetail() {
        const options = { language: 'zh', previewToken };
        const resp: any = await pmsService.getPageDetail(pageCode, options);
        return resp;
    }

    async getModelSeries() {
        // 获取变形金刚目录数据
        const showData = await this.getPageDetail();
        // 设置默认值
        let selectedSerie: any = showData.components[0];
        let selectedModel: any = showData.components[0].modelList[0];
        // 获取配置默认值
        showData.components.forEach((item: any) => {
            item.modelList.forEach((cItem: any) => {
                if (cItem.selected) {
                    item.selected = true;
                    selectedSerie = item;
                    selectedModel = cItem;
                }
            });
        });
        this.setState(
            {
                selectListData: showData.components,
                modelName: selectedModel.modelName,
                seriesName: selectedSerie.seriesName
            },
            () => this.selectCarBook()
        );
    }

    selectCarBook = () => {
        const {
            m10list,
            l6ProList2024,
            l6MaxList2024,
            l7AirList2023,
            l7MaxList2023,
            l7ProList2023,
            l7ProList2024,
            l7UltraList2024,
            l7MaxList2024,
            l8AirList2023,
            l8MaxList2022,
            l8ProList2022,
            l8ProList2024,
            l8UltraList2024,
            l8MaxList2024,
            l9MaxList2022,
            l9ProList2022,
            l9UltraList2024,
            l9ProList2024,
            megaUltraList2024,
            megaUltraList2025,
            megaHomeList2025,
            l6ProList2025,
            l6MaxList2025,
            l7MaxList2025,
            l7ProList2025,
            l7UltraList2025,
            l8MaxList2025,
            l8ProList2025,
            l8UltraList2025,
            l9ProList2025,
            l9UltraList2025,
            seriesName,
            modelName
        } = this.state;
        const carBookArr: Array<any> = [];
        if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Pro 2022款' &&
            l9ProList2022 &&
            l9ProList2022.length > 0
        ) {
            l9ProList2022.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Pro 2024款' &&
            l9ProList2024 &&
            l9ProList2024.length > 0
        ) {
            l9ProList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Pro 智能焕新版' &&
            l9ProList2025 &&
            l9ProList2025.length > 0
        ) {
            l9ProList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Max 2022款' &&
            l9MaxList2022 &&
            l9MaxList2022.length > 0
        ) {
            l9MaxList2022.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Ultra 2024款' &&
            l9UltraList2024 &&
            l9UltraList2024.length > 0
        ) {
            l9UltraList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Ultra 智能焕新版' &&
            l9UltraList2025 &&
            l9UltraList2025.length > 0
        ) {
            l9UltraList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Air 2023款' &&
            l8AirList2023 &&
            l8AirList2023.length > 0
        ) {
            l8AirList2023.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Pro 2024款' &&
            l8ProList2024 &&
            l8ProList2024.length > 0
        ) {
            l8ProList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Pro 2022款' &&
            l8ProList2022 &&
            l8ProList2022.length > 0
        ) {
            l8ProList2022.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Pro 智能焕新版' &&
            l8ProList2025 &&
            l8ProList2025.length > 0
        ) {
            l8ProList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Max 2024款' &&
            l8MaxList2024 &&
            l8MaxList2024.length > 0
        ) {
            l8MaxList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Max 智能焕新版' &&
            l8MaxList2025 &&
            l8MaxList2025.length > 0
        ) {
            l8MaxList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Max 2022款' &&
            l8MaxList2022 &&
            l8MaxList2022.length > 0
        ) {
            l8MaxList2022.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Ultra 2024款' &&
            l8UltraList2024 &&
            l8UltraList2024.length > 0
        ) {
            l8UltraList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Ultra 智能焕新版' &&
            l8UltraList2025 &&
            l8UltraList2025.length > 0
        ) {
            l8UltraList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Air 2023款' &&
            l7AirList2023 &&
            l7AirList2023.length > 0
        ) {
            l7AirList2023.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Pro 2024款' &&
            l7ProList2024 &&
            l7ProList2024.length > 0
        ) {
            l7ProList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Pro 2023款' &&
            l7ProList2023 &&
            l7ProList2023.length > 0
        ) {
            l7ProList2023.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Pro 智能焕新版' &&
            l7ProList2025 &&
            l7ProList2025.length > 0
        ) {
            l7ProList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Max 2024款' &&
            l7MaxList2024 &&
            l7MaxList2024.length > 0
        ) {
            l7MaxList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Max 智能焕新版' &&
            l7MaxList2025 &&
            l7MaxList2025.length > 0
        ) {
            l7MaxList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Max 2023款' &&
            l7MaxList2023 &&
            l7MaxList2023.length > 0
        ) {
            l7MaxList2023.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Ultra 2024款' &&
            l7UltraList2024 &&
            l7UltraList2024.length > 0
        ) {
            l7UltraList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Ultra 智能焕新版' &&
            l7UltraList2025 &&
            l7UltraList2025.length > 0
        ) {
            l7UltraList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L6') > -1 &&
            modelName === 'Pro 智能焕新版' &&
            l6ProList2025 &&
            l6ProList2025.length > 0
        ) {
            l6ProList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L6') > -1 &&
            (modelName === 'Pro' || modelName === 'Pro 2024款') &&
            l6ProList2024 &&
            l6ProList2024.length > 0
        ) {
            l6ProList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L6') > -1 &&
            (modelName === 'Max' || modelName === 'Max 2024款') &&
            l6MaxList2024 &&
            l6MaxList2024.length > 0
        ) {
            l6MaxList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('L6') > -1 &&
            modelName === 'Max 智能焕新版' &&
            l6MaxList2025 &&
            l6MaxList2025.length > 0
        ) {
            l6MaxList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('MEGA') > -1 &&
            modelName === 'Ultra 2024款' &&
            megaUltraList2024 &&
            megaUltraList2024.length > 0
        ) {
            megaUltraList2024.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('MEGA') > -1 &&
            modelName === 'Home 家庭特别版' &&
            megaHomeList2025 &&
            megaHomeList2025.length > 0
        ) {
            megaHomeList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('MEGA') > -1 &&
            modelName === 'Ultra 智能焕新版' &&
            megaUltraList2025 &&
            megaUltraList2025.length > 0
        ) {
            megaUltraList2025.map(item => {
                carBookArr.push(item);
                return carBookArr;
            });
        } else if (
            seriesName.indexOf('ONE') > -1 &&
            modelName === '2021款' &&
            m10list &&
            m10list.length > 0
        ) {
            m10list.map(item => {
                if (item.vehicleModel !== undefined) {
                    if (modelName === '2021款') {
                        if (
                            item.vehicleModel === 0 ||
                            item.vehicleModel === 2
                        ) {
                            carBookArr.push(item);
                        }
                    }
                } else {
                    carBookArr.push(item);
                }

                return carBookArr;
            });
        }
        this.setState({ carBookArr });
    };

    // 切换车系
    getSelectedValue = (seriesName: string, modelName: string) => {
        this.setState(
            {
                modelName,
                seriesName
            },
            () => {
                this.selectCarBook();
            }
        );
    };

    // '基本介绍'
    public render() {
        const {
            modelName = '',
            seriesName = '',
            selectListData = [],
            carBookArr = []
        } = this.state;
        return (
            <>
                <Header />
                {/* <PageHeader title="用户手册" />
                <ModelSelect
                    modelName={modelName}
                    seriesName={seriesName}
                    selectListData={selectListData}
                    selectedValue={this.getSelectedValue}
                /> */}
                {/* <div className="chj-content">
                    <div className="structure">
                        <div className="structure-menu">
                            {carBookArr.length > 0 && (
                                <StructureCatolog
                                    catologData={carBookArr}
                                    onChoiceResult={(item: any) =>
                                        this.onChoiceResult(item)
                                    }
                                    noSearch={true}
                                />
                            )}
                        </div>
                        <div className="structure-content">
                            <iframe className="help" src={this.state.showUrl} />
                        </div>
                    </div>
                </div> */}
                <iframe
                    className="chj-content"
                    src="https://manuals.lixiang.com/index.html"></iframe>
                <Footer />
            </>
        );
    }

    // 切换目录
    private onChoiceResult(item: any) {
        if (item.url) {
            this.urlInit(item.url);
        } else {
            this.setState({
                showUrl: ''
            });
        }
    }

    // 根据车型车系获取URL path
    private getPath() {
        const { seriesName, modelName } = this.state;
        let path = 'help';
        if (seriesName.indexOf('L9') > -1 && modelName === 'Max 2022款') {
            path = 'l9maxhelp2022';
        } else if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Pro 2022款'
        ) {
            path = 'l9prohelp2022';
        } else if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Ultra 2024款'
        ) {
            path = 'l9ultrahelp2024';
        } else if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Ultra 智能焕新版'
        ) {
            path = 'l9ultra2025';
        } else if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Pro 2024款'
        ) {
            path = 'l9prohelp2024';
        } else if (
            seriesName.indexOf('L9') > -1 &&
            modelName === 'Pro 智能焕新版'
        ) {
            path = 'l9pro2025';
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Air 2023款'
        ) {
            path = 'l8airhelp2023';
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Max 2022款'
        ) {
            path = 'l8maxhelp2022';
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Pro 2022款'
        ) {
            path = 'l8prohelp2022';
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Pro 2024款'
        ) {
            path = 'l8prohelp2024';
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Pro 智能焕新版'
        ) {
            path = 'l8pro2025';
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Ultra 2024款'
        ) {
            path = 'l8ultrahelp2024';
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Ultra 智能焕新版'
        ) {
            path = 'l8ultra2025';
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Max 2024款'
        ) {
            path = 'l8maxhelp2024';
        } else if (
            seriesName.indexOf('L8') > -1 &&
            modelName === 'Max 智能焕新版'
        ) {
            path = 'l8max2025';
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Air 2023款'
        ) {
            path = 'l7airhelp2023';
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Pro 2023款'
        ) {
            path = 'l7prohelp2023';
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Max 2023款'
        ) {
            path = 'l7maxhelp2023';
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Pro 2024款'
        ) {
            path = 'l7prohelp2024';
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Max 2024款'
        ) {
            path = 'l7maxhelp2024';
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Ultra 2024款'
        ) {
            path = 'l7ultrahelp2024';
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Pro 智能焕新版'
        ) {
            path = 'l7pro2025';
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Max 智能焕新版'
        ) {
            path = 'l7max2025';
        } else if (
            seriesName.indexOf('L7') > -1 &&
            modelName === 'Ultra 智能焕新版'
        ) {
            path = 'l7ultra2025';
        } else if (
            seriesName.indexOf('L6') > -1 &&
            (modelName === 'Pro' || modelName === 'Pro 2024款')
        ) {
            path = 'l6prohelp2024';
        } else if (
            seriesName.indexOf('L6') > -1 &&
            modelName === 'Pro 智能焕新版'
        ) {
            path = 'l6pro2025';
        } else if (
            seriesName.indexOf('L6') > -1 &&
            (modelName === 'Max' || modelName === 'Max 2024款')
        ) {
            path = 'l6maxhelp2024';
        } else if (
            seriesName.indexOf('L6') > -1 &&
            modelName === 'Max 智能焕新版'
        ) {
            path = 'l6max2025';
        } else if (
            seriesName.indexOf('MEGA') > -1 &&
            (modelName === 'Ultra' || modelName === 'Ultra 2024款')
        ) {
            path = 'megaultrahelp2024';
        } else if (
            seriesName.indexOf('MEGA') > -1 &&
            modelName === 'Ultra 智能焕新版'
        ) {
            path = 'megaultra2025';
        } else if (
            seriesName.indexOf('MEGA') > -1 &&
            modelName === 'Home 家庭特别版'
        ) {
            path = 'megahome2025';
        } else if (seriesName.indexOf('ONE') > -1 && modelName === '2021款') {
            path = 'one';
        }
        return path;
    }

    // 拼接URL
    private urlInit(url: string) {
        let link;
        if (/^[topic-]/.test(url)) {
            const path = this.getPath();

            link = `/autoinfo/${path}/CIN/${url}`;
        } else if (/^[http]/.test(url)) {
            link =
                url.indexOf('?') > -1 ? `${url}&type=web` : `${url}?type=web`;
        } else {
            // @ts-ignore
            link = `/autoinfo/carhelp/${url}?type=web`;
        }
        // TODO: 本地开发调试
        // const link = /^[topic-]/.test(url)
        //     ? `/autoinfo/help/CIN/${url}`
        //     : `http://localhost:3000/${url}?type=web`;
        console.log('link', url, link);
        this.setState({
            showUrl: link
        });
    }
}

ReactDOM.render(<App />, document.getElementById('app'));
/* eslint-enable */
